import SsoUser from './sso_fetch_user';

export function createAccount({
  email,
  globals = { host: '', version: '', url_params: {}, plid: '' },
  username,
  password,
  last_name,
  first_name,
  session_id,
  mobile_phone,
  consent_preferences,
  target_application,
}) {
  const sso_user = new SsoUser(globals.host, globals.version);
  return sso_user.create_new_shopper(
    email,
    username,
    password,
    session_id,
    consent_preferences,
    first_name,
    last_name,
    mobile_phone,
    globals,
    target_application,
  );
}
